import { Component, forwardRef, Input, OnChanges } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { LengthInputComponent } from '../length-input/length-input.component'

@Component({
  selector: 'efp-length-input-editor',
  templateUrl: 'length-input-editor.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LengthInputEditorComponent),
      multi: true,
    },
  ],
})
export class LengthInputEditorComponent
  extends LengthInputComponent
  implements ControlValueAccessor, OnChanges
{
  @Input() required = false
  @Input() step = 1
  @Input() showStep = true
  @Input() label?: string
  @Input() alert?: string
  @Input() desc?: string

  valueInCm?: number
  valueInUnit?: number | string

  private onTouched: () => void = () => {}

  override registerOnChange(fn: (val: number | undefined) => void): void {
    this.onChange = fn
  }

  override registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }
}
